import type { ReactNode } from 'react';
import { FunnelSimpleIcon } from '@phosphor-icons/react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';
import {
  ResultsShareButton,
  type ResultsShareCopy,
} from '../../shared/results_page/results_share.js';
import type { HotelOfferView } from '../models.js';

/** O compartilhar do card da conversa (#5156): o PDF leva os hotéis do dock —
 *  os que o card mostra —, não a busca inteira. */
export type HotelResultsShare = {
  copy: ResultsShareCopy;
  onCopyLink: () => void;
  onDownloadPdf: (offers: readonly HotelOfferView[]) => void;
  /** A busca venceu ou o card ficou só de leitura: os preços podem estar velhos,
   *  então o PDF fica no menu, desabilitado — o link refaz a busca. */
  pdfDisabled?: boolean;
};

/** O rodapé do palco de resultado do card: o compartilhar (com o port do host) e a
 *  saída para a listagem determinística. */
export function HotelResultsFooter({
  expandLabel,
  offers,
  share,
  onSeeAll,
}: Readonly<{
  expandLabel: string;
  offers: readonly HotelOfferView[];
  share: HotelResultsShare | undefined;
  onSeeAll: () => void;
}>): ReactNode {
  return (
    <div className="hui-hotel-results-footer">
      {share && (
        <ResultsShareButton
          look="outline"
          share={{
            copy: share.copy,
            onCopyLink: share.onCopyLink,
            onDownloadPdf: () => {
              share.onDownloadPdf(offers);
            },
            ...(share.pdfDisabled ? { pdfDisabled: true } : {}),
          }}
        />
      )}
      {/* `outline lg` com o funil, como o `Ver todos os hotéis` do protótipo:
          a saída para a listagem determinística é chrome, não decisão. */}
      <Button variant="outline" size="lg" data-hotel-results-expand-trigger="" onClick={onSeeAll}>
        <FunnelSimpleIcon data-icon="inline-start" aria-hidden="true" />
        {expandLabel}
      </Button>
    </div>
  );
}
